export default function parseCSV(text: string): string[][] {
  const rows: string[] = text.trim().split('\n')
  const result: string[][] = []

  for (const row of rows) {
    const values: string[] = []
    let current = ''
    let inQuotes = false

    for (let i = 0; i < row.length; i++) {
      const char = row[i]
      const nextChar = row[i + 1]

      if (char === '"' && inQuotes && nextChar === '"') {
        current += '"'
        i++
      } else if (char === '"') {
        inQuotes = !inQuotes
      } else if (char === ',' && !inQuotes) {
        values.push(current)
        current = ''
      } else {
        current += char
      }
    }

    values.push(current)
    result.push(values)
  }

  return result
}
